import { render, staticRenderFns } from "./Preaspirantes.vue?vue&type=template&id=22bcccfb&scoped=true"
import script from "./Preaspirantes.vue?vue&type=script&lang=js"
export * from "./Preaspirantes.vue?vue&type=script&lang=js"
import style0 from "./Preaspirantes.vue?vue&type=style&index=0&id=22bcccfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bcccfb",
  null
  
)

export default component.exports